import {
  FILTER_PARAMS,
  TRACK_RELEASE_TYPE_OPTIONS,
  TRACK_ROLE_OPTIONS,
} from '../constants';
import type {
  ReleasesFilters,
  TrackReleaseTypeOptions,
  TrackRoleOptions,
} from '../types';

function getValue<T extends readonly string[]>(
  urlParams: URLSearchParams,
  name: string,
  validValues: T,
): T[number] | undefined {
  const value = urlParams.get(name);

  if (value && validValues.includes(value)) {
    return value as T[number];
  }
}

export function parseFiltersFromUrlParams(
  urlParams: URLSearchParams,
): ReleasesFilters {
  const searchText = urlParams.get(FILTER_PARAMS.searchText) || undefined;

  const releaseType = getValue<TrackReleaseTypeOptions>(
    urlParams,
    FILTER_PARAMS.releaseType,
    TRACK_RELEASE_TYPE_OPTIONS,
  );

  const role = getValue<TrackRoleOptions>(
    urlParams,
    FILTER_PARAMS.role,
    TRACK_ROLE_OPTIONS,
  );

  return {
    searchText,
    releaseType,
    role,
  };
}

/**
 * Function takes a set of ReleasesFilters and returns URLSearchParams
 */
export function formatFiltersToUrlParams(
  filters: Partial<ReleasesFilters>,
): URLSearchParams {
  const newUrlParams = new URLSearchParams();

  if (filters.searchText) {
    newUrlParams.set(FILTER_PARAMS.searchText, filters.searchText);
  }

  if (
    filters.releaseType &&
    TRACK_RELEASE_TYPE_OPTIONS.includes(filters.releaseType)
  ) {
    newUrlParams.set(FILTER_PARAMS.releaseType, filters.releaseType);
  }

  if (filters.role && TRACK_ROLE_OPTIONS.includes(filters.role)) {
    newUrlParams.set(FILTER_PARAMS.role, filters.role);
  }

  return newUrlParams;
}
